import portalApiClient from './client/portal-api';
import DrafterSearch from '@/core/model/drafter-search';
import type GoodClass from '@/core/model/good-class';
import HttpResponse from '../http-module/http-response';

const drafter = {
    async search(search: string, appReference: string, countryCode: string): Promise<DrafterSearch> {
        const response = await portalApiClient.get(countryCode + '/drafter-search?q=' + search + '&ref=' + appReference);

        if (response instanceof HttpResponse) {
            const drafterSearch = new DrafterSearch();
            const data = response.content.data as [];
            data.forEach((goodClassItem: any) => {
                const goodClass: GoodClass = {
                    id: goodClassItem.id,
                    classNumber: goodClassItem.number,
                    name: goodClassItem.name,
                    suggestions: [],
                    matches: []
                };

                goodClassItem.suggestions.forEach((good: any) => {
                    goodClass.suggestions.push({
                        externalId: good.id,
                        classNumber: good.class_number,
                        name: good.name,
                    });
                });

                drafterSearch.addClass(goodClass);
            });

            return drafterSearch;
        }

        return new DrafterSearch();
    }
};

export default drafter;
